import { Theme } from '@sbv-clients/ui-shared';

export const sideBarStyles = (theme: Theme) => ({
  top: '66px',
  height: 'auto',
  right: '10px',
  bottom: '22px',
  borderWidth: '1px 0px 1px 1px',
  borderStyle: 'solid',
  borderColor: theme.colors.border.menuButton,
  borderRadius: 1,
  borderTopRightRadius: '0px',
  borderBottomRightRadius: '0px',
});
